module.exports = __webpack_public_path__ + "static/media/brand-refresh-arrow-right-disabled.6ba5657b.svg";